"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textNodeValue = exports.serializeNode = exports.selectNodes = exports.selectNode = exports.parseXmlToDocumentElement = exports.parseXmlBooleanDefaultFalse = exports.parseXmlBoolean = exports.makeAttributeObj = exports.isWhitespaceTextNode = exports.isTextNode = exports.isAllWhitespace = exports.getTextContent = exports.getNodeName = exports.getImmediateTextContent = exports.getChildElementValue = exports.getAttributeValueMap = exports.getAttributeObjectMap = exports.extractNamespaces = exports.domElementToObj = exports.childEl = exports.attributeToObject = void 0;
var _ramda = require("ramda");
var _buildXml = require("@qdabra/build-xml");
var _xmldom = require("@xmldom/xmldom");
var _funcXml = require("func-xml");
var _makeMap = _interopRequireDefault(require("../helpers/makeMap"));
var _nodeTypes = require("../constants/nodeTypes");
var _xmlNamespaces = require("../constants/xmlNamespaces");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var serializer = new _xmldom.XMLSerializer();
var regexWhitespace = /^[ \r\n\t]*$/;
var serializeNode = exports.serializeNode = function serializeNode(node) {
  return serializer.serializeToString(node);
};
var childEl = exports.childEl = function childEl(localName, namespace) {
  return (0, _ramda.compose)(_ramda.head, (0, _funcXml.childEls)(localName, namespace));
};
var parseXmlToDocumentElement = exports.parseXmlToDocumentElement = (0, _ramda.compose)((0, _ramda.prop)('documentElement'), function (str) {
  return (0, _buildXml.parseXmlString)(str, new _xmldom.DOMParser());
});

// DOMNode -> { String: String }
var extractNamespaces = exports.extractNamespaces = (0, _ramda.compose)((0, _makeMap["default"])(_funcXml.localName, (0, _ramda.prop)('value')), (0, _ramda.filter)((0, _ramda.propEq)('prefix', 'xmlns')), _funcXml.allAttributes);
var NODE_NAME_PROPERTY = 'nodeName';

// Returns the node's name, with prefix if there is one
var getNodeName = exports.getNodeName = (0, _ramda.prop)(NODE_NAME_PROPERTY);
var domElementToObj = exports.domElementToObj = function domElementToObj(element) {
  return {
    type: element.localName,
    name: getNodeName(element),
    namespaceURI: element.namespaceURI
  };
};
var attributeToObject = exports.attributeToObject = (0, _ramda.pick)(['localName', 'name', 'value', 'namespaceURI']);

// DOMNode -> { String: AttributeObject }
var getAttributeObjectMap = exports.getAttributeObjectMap = (0, _ramda.compose)((0, _makeMap["default"])(getNodeName, attributeToObject), _funcXml.allAttributes);

// DOMElement -> { String: String }
var getAttributeValueMap = exports.getAttributeValueMap = (0, _ramda.compose)((0, _makeMap["default"])(getNodeName, (0, _ramda.prop)('value')), _funcXml.allAttributes);
var isTextNode = exports.isTextNode = (0, _ramda.propEq)('nodeType', _nodeTypes.TEXT_NODE);
var textNodeValue = exports.textNodeValue = (0, _ramda.prop)('data');
var isAllWhitespace = exports.isAllWhitespace = (0, _ramda.test)(regexWhitespace);
var isWhitespaceTextNode = exports.isWhitespaceTextNode = (0, _ramda.both)(isTextNode, (0, _ramda.compose)(isAllWhitespace, textNodeValue));
var makeAttributeObj = exports.makeAttributeObj = function makeAttributeObj(localName, value) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : localName;
  var namespaceURI = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  return {
    localName: localName,
    name: name,
    namespaceURI: namespaceURI,
    value: value
  };
};
var selectNodes = exports.selectNodes = (0, _ramda.curry)(function (parsedXPath, node) {
  return parsedXPath.select({
    node: node,
    namespaces: _xmlNamespaces.namespaces
  });
});
var selectNode = exports.selectNode = (0, _ramda.curry)(function (parsedXPath, node) {
  return parsedXPath.select1({
    node: node,
    namespaces: _xmlNamespaces.namespaces
  });
});

// DOMNode -> String
var getImmediateTextContent = exports.getImmediateTextContent = (0, _ramda.compose)((0, _ramda.join)(''), (0, _ramda.reject)(isAllWhitespace), (0, _ramda.map)(textNodeValue), (0, _ramda.filter)(isTextNode), _funcXml.allChildNodes);

// DOMNode -> String
var getTextContent = exports.getTextContent = (0, _ramda.prop)('textContent');
var parseXmlBoolean = exports.parseXmlBoolean = function parseXmlBoolean(value) {
  switch (value) {
    case 'true':
    case '1':
      return true;
    case 'false':
    case '0':
      return false;
    case '':
    case null:
      return null;
    default:
      console.warn('invalid boolean value:', value);
      return null;
  }
};
var parseXmlBooleanDefaultFalse = exports.parseXmlBooleanDefaultFalse = (0, _ramda.compose)((0, _ramda.defaultTo)(false), parseXmlBoolean);
var getChildElementValue = exports.getChildElementValue = (0, _ramda.curry)(function (name, parent) {
  var el = childEl(name)(parent);
  return el ? getTextContent(el) : null;
});